import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../../../shared';
import { ContatoTipoSelectComponent } from './contato-tipo-select.component';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        ContatoTipoSelectComponent
    ],
    exports: [
        ContatoTipoSelectComponent
    ]
})
export class ContatoTipoSelectModule { }
